import { dispatchAction } from "../../store";
import { setTheme } from "./slice";

export const updateTheme = (theme: string) => {
  dispatchAction(setTheme(theme));
};
